// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"27":"2fd449b0519d297f","52":"dbe5fdd2a03da3d2","199":"da1b83560f13395b","320":"25c7cc22c792577e","372":"106f3ccaeb83c180","454":"b4ab45076717e7b7","554":"0daec4470cc8e8d1","583":"d18bce69189090b1","586":"584b0249275bd66a","806":"0b3350701d0b26c9"}[chunkId] + ".js";
};